import React from "react";
import ReactGA from "react-ga";
import _ from "lodash";
import RouteProfile from "./RouteProfile";
import ElevationGraph from "./ElevationGraph";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { getCurrentPage } from "../helpers";
import RoutePlanDownload from "./RoutePlanDownload";

class RouteSummary extends React.Component {
    state = {
        detailsToggle: false,
    };

    handleDetailsToggle = (e) => {
        e.preventDefault();

        // GA Track
        ReactGA.event({
            category: _.startCase(getCurrentPage()),
            action: "Toggle result details",
            label: this.state.detailsToggle === true ? "Hide" : "Show",
        });

        this.setState({
            detailsToggle: !this.state.detailsToggle,
        });
    };

    render() {
        const current = this.props.currentJourney.currentJourney;
        const data = this.props.cycleRoutes[current].marker[0]["@attributes"];
        const summary = this.props.cycleRoutes[current].summary;

        // Valid locations for parking are route locations and GeoLocation
        const valid_locations = _.filter(
            this.props.locations,
            (location) => location.lat && location.lng
        );

        if (this.props.map.userLocation) {
            valid_locations.push(this.props.map.userLocation);
        }

        return (
            <div className="route-summary-wrapper">
                <div className="route-summary">
                    <ul className="summary-list">
                        <li className="summary-item summary-duration">
                            <svg className="icon" aria-hidden="true">
                                <use xlinkHref="#clock" />
                            </svg>
                            <span className="summary-item__title faint">
                                Time
                            </span>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: summary.duration.text,
                                }}
                            ></span>
                        </li>

                        <li className="summary-item summary-distance">
                            <svg className="icon wide-icon" aria-hidden="true">
                                <use xlinkHref="#road" />
                            </svg>
                            <span className="summary-item__title faint">
                                Distance
                            </span>
                            <span className="value">
                                {summary.distance} miles
                            </span>
                        </li>

                        <li className="summary-item summary-elevation">
                            <svg className="icon wide-icon" aria-hidden="true">
                                <use xlinkHref="#elevation-up" />
                            </svg>
                            <span className="summary-item__title faint">
                                Incline
                            </span>
                            <span
                                className="value"
                                aria-label={`${summary.ascent} metres`}
                            >
                                {summary.ascent} m
                            </span>
                        </li>

                        <li className="summary-item summary-elevation">
                            <svg className="icon wide-icon" aria-hidden="true">
                                <use xlinkHref="#elevation-down" />
                            </svg>
                            <span className="summary-item__title faint">
                                Decline
                            </span>
                            <span
                                className="value"
                                aria-label={`${summary.descent} metres`}
                            >
                                {summary.descent} m
                            </span>
                        </li>
                    </ul>
                </div>

                <div className="route-summary-elevation">
                    <ElevationGraph {...this.props} />
                </div>

                <div className="route-summary-downloads">
                    <RoutePlanDownload {...this.props} />
                </div> 
            

                <div className="route-details-wrapper">
                    <div className="small-content">
                        <RouteProfile {...this.props} />
                    </div>

                    <header className="route-details-header sidebar-divider">
                        <button
                            href="#"
                            className="toggle-details"
                            onClick={(e) => this.handleDetailsToggle(e)}
                            aria-controls="route-details-toggle"
                            aria-expanded={
                                this.state.detailsToggle ? true : false
                            }
                        >
                            <h2 className="divider-title">
                                {this.state.detailsToggle ? "Hide" : "View"}{" "}
                                Route Details
                            </h2>
                            <svg
                                className={
                                    this.state.detailsToggle
                                        ? "icon hide"
                                        : "icon show"
                                }
                                aria-hidden="true"
                            >
                                <use
                                    xlinkHref={
                                        this.state.detailsToggle
                                            ? "#arrow-small-up"
                                            : "#arrow-small-down"
                                    }
                                />
                            </svg>
                        </button>
                    </header>

                    <CSSTransitionGroup
                        transitionName="route-details-slide"
                        transitionEnterTimeout={400}
                        transitionLeaveTimeout={400}
                    >
                        {this.state.detailsToggle && (
                            <div
                                id="route-details-toggle"
                                className="route-details"
                            >
                                <ul className="route-details-list">
                                    <li>
                                        <span>Quietness</span>{" "}
                                        <span>{data.quietness}</span>
                                    </li>
                                    <li>
                                        <span>Crossing delays </span>{" "}
                                        <span>{data.signalledCrossings}</span>
                                    </li>
                                    <li>
                                        <span>Traffic lights </span>
                                        <span>{data.signalledJunctions}</span>
                                    </li>
                                    <li>
                                        <span>Calories burnt</span>{" "}
                                        <span>{data.calories}</span>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </CSSTransitionGroup>
                </div>
            </div>
        );
    }
}

export default RouteSummary;



// WEBPACK FOOTER //
// ./src/components/RouteSummary.js